import type { ReactNode } from 'react';
import classNames from 'classnames';
import { type TestId } from '@repo/test-id';
import { Card, LoadingOverlay } from '@repo/ui';

import cardGlow from '@assets/images/parking-manage/card-glow.svg';

type Variant = 'light' | 'dark';

interface Props {
  title: string;
  counter: number;
  variant: Variant;
  loading: boolean;
  testId: TestId;
  children: ReactNode;
}

export default function DashboardGlowingCard({ title, counter, variant, loading, testId, children }: Props) {
  return (
    <Card
      className={classNames('flex-1', {
        'bg-dark-subtle!': variant === 'dark',
        'bg-brand!': variant === 'light',
      })}
    >
      <div className="flex flex-col gap-1">
        <img src={cardGlow} alt="" className="pointer-events-none absolute bottom-0 left-0 h-40 w-40" aria-hidden />
        <div className="text-sm leading-5 text-white">{title}</div>
        <LoadingOverlay loading={loading} className="text-white">
          <div className="flex flex-col gap-2">
            <div className="pb-1 text-3xl leading-11 font-semibold" data-testid={testId.append('counter')}>
              {counter}
            </div>
            <div>{children}</div>
          </div>
        </LoadingOverlay>
      </div>
    </Card>
  );
}
